module.exports = __webpack_public_path__ + "img/photo_green.a3babafe.png";